module.exports = __webpack_public_path__ + "img/homeoff.cfcdb625.svg";